// hooks/useProfile.js

import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { config } from 'react-spring';
import { INITIALIZE_PROFILE } from 'store/actions';
import { useDispatch } from 'react-redux';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore } from '../firebase';

export default function useProfile() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [user] = useAuthState(auth);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        console.log(user);

        const profilesRef = firestore.collection('profiles');
        const profile = await profilesRef.doc(user.uid).get();

        if (profile.exists) {
          // Parse existing profile
          const profileData = profile.data();
          console.log('Profile Exists: ', profileData);

          // Initialize profile in Redux
          dispatch({
            type: INITIALIZE_PROFILE,
            payload: profileData
          });
        } else {
          console.log('Profile does not exist.');

          // Create initial profile data
          const profileData = {
            uid: user.uid,
            name: user.displayName,
            authProvider: provider,
            email: user.email,
            complete: true,
            details: {
              firstName: (user.displayName && user.displayName.split(' ').length > 1)
                ? user.displayName.split(' ')[0]
                : null,
              lastName: null
            },
            account: {
              role: 'CLIENT',
              imageUrl: config.account.imageUrl,
              membership: [config.account.id]
            }
          };

          // Create new profile in Firestore
          await profilesRef.doc(user.uid).set(profileData);

          // Initialize profile in Redux
          dispatch({
            type: INITIALIZE_PROFILE,
            payload: profileData
          });

          // TODO: determine proper navigation logic
          // Navigate to home
          history.push('/admin/home');
        }
      } catch (err) {
        console.error('Error loading profile:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  return {
    loading,
    error
  };
}
